'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * Fetch the current exchange rates for the given coin Id vs select fiat currencies.
 *
 * @param {Array} currencyCodes
 *
 * @returns {Object} the exchangeRates by currency code.
 */
exports.default = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(coinId, currencyCodes) {
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', fetch(_constants.COINGECKO_API_EXCHANGE_RATE_ENDPOINT + '?ids=' + coinId + '&vs_currencies=' + currencyCodes.join(',')).then(function (response) {
              if (response.ok) {
                return response.json();
              }
              throw new Error(response.statusText ? response.statusText : 'Invalid Request');
            }).then(function (result) {
              if (result[coinId]) {
                return result[coinId];
              }
              throw new Error('No exchange rate data found for ' + coinId);
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/services/fetchCurrencyExchangeRates.js
// module id = 1282
// module chunks = 0